<template>
    <div class="carlist_wrapper">
        <!--品牌-->
        <div class="series_wrapper" v-if="series_show">
            <div class="header_wrapper">
                <b class="left_title">选择品牌</b>
            </div>
            <div class="out_main_wrapper">
                <div class="main_wrapper_series">
                    <div class="left_firstseries" ref="left_firstseries">
                        <!--热门-->
                        <div>
                            <img src="../../assets/image/usedcar/shellcar.jpg" style="width: 100%;">
                        </div>
                        <div class="hot_wrapper" v-if="hot.length>0">
                            <div class="hot_title">
                                <b>热门品牌</b>
                                <img src="../../assets/image/hot.png">
                            </div>
                            <ul class="hot_list_wrapper">
                                <li v-for="(item,index) in hot" :key="index" @click="clk_brand(item)">
                                    {{item.brand_name}}
                                </li>
                            </ul>
                        </div>
                        <!--列表-->
                        <div class="series_list_wrapper" @scroll="handleScroll()" ref="series_list_wrapper">
                            <template v-for="(brands, letter) in brand">
                                <div :key="letter">
                                    <div class="hot_title series_tilte character" :id="letter">{{letter}}</div>
                                    <ul class="series_list">
                                        <li class="series_list_item"
                                            v-for="brand in brands" :key="brand.id" @click="clk_brand(brand)"
                                        >
                                            {{brand.brand_name}}
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!--右侧-->
                    <div class="right_letters">
                        <ul>
                            <li v-for="(item, index) in letter" :key="index" @click="to_letter(index,item)"
                                :class="activeLetter == item ? 'cur' : ''"
                            >{{item}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!--车型-->
        <div class="brand_wrapper" v-if="brand_show">
            <div class="header_wrapper">
                <van-icon name="arrow-left" @click="goback"/>
                <b class="left_title">{{brand_name}}</b>
                <van-icon name="cross" @click="closePopup"/>
            </div>
            <div class="main_wrapper_brand">
                <ul>
                    <!--  brand_list-->
                    <!--  @click="clk_series(brand_id, brand_name, series.series_id, series.series_name)"-->
                    <li class="series_list_item"
                        v-for="(series, series_id) in series_list" :key="series_id"
                        @click="clk_series(series)"

                    >{{series.series_name}}
                    </li>
                </ul>
            </div>
        </div>

        <!-- 车款-->
        <div class="brand_wrapper product_wrapper" v-if="product_show">
            <div class="header_wrapper">
                <van-icon name="arrow-left" @click="goback_brand"/>
                <b class="left_title">{{series_name}}</b>
                <van-icon name="cross" @click="closePopup"/>
            </div>
            <div class="main_wrapper_brand">
                <ul>
                    <li class="series_list_item"
                        v-for="(product, id) in product_list" :key="id"
                        @click="clk_product(brand_id, brand_name, series_id, series_name,product.id,product.product_name)"
                    >{{product.product_name}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import lib_car from "@/libs/lib_car";

    export default {
        props: {
            activity_id: {type: Number, default: 0}, //项目id
            custom_car: {type: Number, default: 0}, //是否自定义车型库
            is_dialog_car: {type: Boolean, default: false}
        },

        data() {
            return {
                hot: [], //热门车型
                brand: [], //品牌
                letter: [], //右侧ABC
                series_list: [], //车型
                product_list: [], //车款
                brand_id: undefined, //品牌id
                brand_name: '', //品牌name
                series_name: '', //车型name
                series_id: undefined, //车型id
                product_name: '', //车款name
                product_id: undefined, //车款id
                currIndex: 0,
                activeLetter: 'A',
                is_active: false, //获取点击字母


                is_brand: true,
                current_brand: {},

                series_show: true,
                brand_show: false,
                product_show: false,
            };
        },
        created() {
            // todo 车型加载及两次请求， 无图片的(两个组件) 参数控制加载A/B
            // todo 单品，无弹框，下拉处理
            let that = this;

            lib_car.brandx(function (data) {
                console.log(data.brand, '===')
                that.hot = data.hot;
                that.letter = data.letter;
                that.brand = data.brand;
                that.activeLetter = data.letter[0];
            })
            this.$nextTick(() => {
                window.addEventListener('scroll', this.handleScroll())
            })
        },
        mounted() {

        },

        methods: {
            //字母
            to_letter(index, item) {
                this.is_active = index;
                this.currIndex = index;
                this.activeLetter = item;
                document.querySelector('#' + this.activeLetter).scrollIntoView({
                    behavior: 'smooth'
                })
            },
            // 滚动
            handleScroll() {
                let leftEle = [...document.querySelectorAll('.character')];
                let leftWrapper = this.$refs.series_list_wrapper;
                let leftHotHeight = this.$refs.left_firstseries.scrollTop;
                leftEle.forEach((item, index) => {
                    if (item.offsetTop < leftWrapper.offsetTop + leftHotHeight - 30) {
                        this.activeLetter = item.innerText
                    }
                })
            },
            //选择品牌
            clk_brand(brand) {
                this.current_brand = brand;
                this.brand_id = brand.brand_id; // 品牌id
                this.brand_name = brand.brand_name;  // 品牌name
                this.series_show = false;
                this.brand_show = true;
                let that = this;
                lib_car.seriesx(brand.brand_id, function (data) {
                    that.series_list = data
                })

            },

            //选择车型
            clk_series(series) {
                this.series_show = false;
                this.brand_show = false;
                this.product_show = true;
                this.series_name = series.series_name;
                let that = this
                lib_car.productx(series.series_id, function (data) {
                    that.product_list = data;
                })
            },
            clk_product(brand_id, brand_name, series_id, series_name, product_id,product_name) {
                this.product_show = false;
                this.series_show = false;
                this.brand_show = false
                this.$emit("query", brand_id, brand_name, series_id, series_name, product_id,product_name);

            },

            // others methods
            closePopup() {
                this.$emit('handleClose', false)
            },
            goback() {
                this.brand_show = false;
                this.series_show = true;
            },
            goback_brand() {
                this.product_show = false;
                this.series_show = false;
                this.brand_show = true
            }
        },
        watch: {
            is_dialog_car(v) {
                this.series_show = v;
                this.brand_show = false;
            },
            series_show(v) {
                if (v == false) {
                    this.activeLetter = this.letter[0]
                    window.removeEventListener('scroll', this.handleScroll())
                }
            }
        }
    };
</script>

<style lang="less">
    @import "../../assets/style/carList/carlist_noimg.less";
</style>
